import { QueryKeys, useCustomQuery } from './index';
import Config from '../../config';
import { FetchedClient } from '../../administration/clientPage/types';

export const useClientsForUser = () =>
  useCustomQuery(
    QueryKeys.client.ClientListForUser,
    {
      url: Config.endpoints.FETCH_USER_CLIENT_LIST,
      errorMessage: 'Fetching clients failed',
      defaultData: [],
    }
  );

export const useClientList = () =>
  useCustomQuery<FetchedClient[]>(
    QueryKeys.client.ClientList,
    {
      url: Config.endpoints.FETCH_CLIENT_LIST,
      errorMessage: 'Fetching clients failed',
      defaultData: [],
    }
  );
